import React, { useContext, useMemo, useState } from "react";
import { Col, Container, Row, Card, CardBody, CardTitle, Spinner, Alert } from "reactstrap";
import { useQuery } from "react-query";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import { getFormulaire, getFormulaireyId } from "../services/formulaireApi";
import "../utils/style.css";
import AddTypeFormulaireForm from "./CreateTypeFomulaire"; // Modal importée
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { Avatar, Button, Modal, Spin } from "antd";

const DetailFormulaire = () => {
  const history = useContext(HistoryContext);
  const { t } = useTranslation();
  document.title = `Formulaires | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;

  const { id } = useParams();
  const { data: formulaire, isLoading, isError, error } = useQuery(['formulaire', id], () => getFormulaireyId(id));
  const { data: formulaires, isLoading: isFormulairesLoading, isError: isFormulairesError } = useQuery('formulaires', getFormulaire);
  const navigate = useNavigate(); // Ajouté : pour naviguer entre les pages
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);
  
  const [isModalOpenView, setIsModalOpenView] = useState(false);
  const toggleModalView = () => setIsModalOpenView(!isModalOpenView);
  
  // Ajouté : fonction pour rediriger vers le détail du formulaire basé sur le type
  const handleDetail = (type) => {
    navigate(`/formulaire/type/${type}`); // Redirige vers la page avec l'ID du formulaire
  };

  const formulairesInSameCategory = useMemo(() => {
    if (formulaires && formulaire) {
      return formulaires.filter(v => v.category === formulaire.category && v.id !== formulaire.id); // Exclure le formulaire actuel
    }
    return [];
  }, [formulaires, formulaire]);

  const groupedByType = useMemo(() => {
    const group = {};
    formulairesInSameCategory.forEach(item => {
      if (!group[item.type]) {
        group[item.type] = [];
      }
      group[item.type].push(item); // Grouper les formulaires par type
    });
    return group;
  }, [formulairesInSameCategory]);

  const uniqueTypes = useMemo(() => {
    return Object.keys(groupedByType); // Liste des types uniques
  }, [groupedByType]);

  if (isLoading || isFormulairesLoading) {
    return <Spinner color="primary" />;
  }

  if (isError || isFormulairesError) {
    return <Alert color="danger">{error?.message || 'Une erreur est survenue.'}</Alert>;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb page="Détail formulaire d'inspection catégorie" history={history} />

          <Row className="justify-content-center">
            <Col lg={12}>
              <Card className="card">
                <CardBody>
                  <CardTitle tag="h4" className="mb-4 category">
                    {formulaire?.category}
                  </CardTitle>
                  <div>
                    {uniqueTypes.length > 0 ? (
                      uniqueTypes.map((type) => (
                        <Card key={type} className="mb-3" style={{ border: '1px solid #D9D9D9' }}>
                          <CardBody>
                            <CardTitle className="type" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <span>{type}</span>
                              {/* Ajouté : onClick pour naviguer vers le détail du type */}
                              <span className="points" onClick={() => handleDetail(type)}>
                                <EyeOutlined style={{ color: ' #898989', width: '20px' }} />
                              </span>
                            </CardTitle>
                            <div className="name" tag="h6">
                              {formulaire?.type === type && (
                                <span key={formulaire?.id}>
                                  {formulaire?.name}
                                  {', '}
                                </span>
                              )}
                              {groupedByType[type].map((item, index) => (
                                <span key={item.id}>
                                  {item.name}
                                  {index < groupedByType[type].length - 1 && ", "}
                                </span>
                              ))}
                            </div>
                          </CardBody>
                        </Card>
                      ))
                    ) : (
                      <p>Aucun autre formulaire dans cette catégorie.</p>
                    )}
                  </div>
                  <Row>
                    <Col md={4}>
                      <Button
                        className="bordered-btn-lightN"
                        color="light"
                        onClick={toggleModal} // Ouvre la modal
                      >
                        Ajouter une nouvelle partie
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Modal pour Voir les détails */}
          <Modal
            open={isModalOpenView}
            cancel={() => toggleModalView()}
            footer={null}
            width={206}
            height={10}
            radiuis={9.6}
            border={0.96}
            onCancel={() => toggleModal()}
            style={{ top: '350px', right: '10px', position: 'absolute' }}
          >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              {/* Ajouté : onClick pour naviguer vers le détail du type */}
              <a
                onClick={() => handleDetail(formulaire?.type)} // Redirige vers la page avec le type sélectionné
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: '8px',
                  fontFamily: "inter",
                  fontWeight: '400px',
                  width: "100%",
                  marginBottom: "16px"
                }}
              >
                <EyeOutlined style={{ color: ' #898989', width: '20px' }} />
                <span className="detailEditer">Voir détails</span>
              </a>
              {/* D'autres options comme Editer et Supprimer */}
            </div>
          </Modal>

          {/* Modal AddTypeFormulaireForm */}
          <AddTypeFormulaireForm
            modal={isModalOpen}
            setModal={setIsModalOpen}
            isOpen={isModalOpen}
            toggle={toggleModal}
            selectedCategory={formulaire?.category}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DetailFormulaire;
